import { jsxs as v, jsx as l } from "react/jsx-runtime";
const c = (o) => /* @__PURE__ */ v(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...o,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m21.98 17.498 1.897-.526v-.045l.051-.014V6.01h-.03l-1.97.53v10.91l.051-.014v.063ZM27.202 6.17l-1.897.525v10.803l1.897-.526V6.17Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M28.777 6.8v10.409c0 1.19-.234 4.106-2.406 5.48l-.698.442V53.46l-2.194.6V23.13l-.697-.441c-2.173-1.375-2.407-4.291-2.407-5.481V6.019l-3 .805v10.385c0 1.988.41 3.741 1.218 5.21a7.86 7.86 0 0 0 1.886 2.3v33.269l5.974-1.632-.776-2.89 2.996-.804V24.718a7.857 7.857 0 0 0 1.887-2.298c.808-1.47 1.217-3.223 1.217-5.211V6.01h-.06l-2.94.79ZM46.436 6.166h-1.5c-1.155 0-4.098.549-6.465 5.639-1.98 4.26-2.983 10.428-2.979 18.335l.001 1.16 2.75.715v25.973l5.984-1.635-.775-2.887 2.984-.801v-46.5Zm-3 47.293-2.194.6V29.694l-2.742-.713c.068-5.007.62-11.456 2.692-15.912.74-1.591 1.532-2.615 2.244-3.214V53.46Z"
        }
      )
    ]
  }
);
export {
  c as Food
};
